import { type ReactNode, type FC } from 'react';
import { Box, Text } from '@chakra-ui/react';
import RequestOperationButton from './RequestOperationButton';
import SearchResults from './SearchResults';
import { type OperationViewModel } from '../../../Map/types';
import { ReactComponent as Globe } from '../../../../assets/svg/Globe.svg';
import { translateAndFormat } from '../../../../constants/translation';

interface Props {
  operationResults: OperationViewModel[];
  isLoading: boolean;
  onOperationSelected: (operation: string) => void;
  onSearchClose: () => void;
  searchPhrase: string;
}

const OperationSearchResults: FC<Props> = ({
  operationResults,
  isLoading,
  onOperationSelected,
  onSearchClose,
  searchPhrase,
}) => {
  const selectOperation = (operation: OperationViewModel): void => {
    onOperationSelected(operation.key);
    onSearchClose();
  };

  const operationNodeFactory = (operation: OperationViewModel, index: number): ReactNode => {
    return (
      <Box
        key={index}
        className="result-item"
        onClick={() => {
          selectOperation(operation);
        }}
      >
        <Globe className="result-icon" />
        <div className="result-text text-sm-regular">{operation.name}</div>
      </Box>
    );
  };

  const noResultsMessage = (
    <div className="no-result-actions">
      <Text className="text-sm-regular">{translateAndFormat('NO_OPERATIONS_FOUND_FOR', searchPhrase)}</Text>
      <RequestOperationButton />
    </div>
  );

  return (
    <SearchResults<OperationViewModel>
      results={operationResults}
      isLoading={isLoading}
      headerTranslationKey="OPERATIONS"
      resultNodeFactory={operationNodeFactory}
      noResultsMessage={noResultsMessage}
    />
  );
};

export default OperationSearchResults;
